





















































import { computed, defineComponent, PropType, toRefs } from '@vue/composition-api';
import TTIcon from '@tt4b/ttam-assets/src/svgs/creative/tt-account-icon.svg';
import UnbindIcon from '@tt4b/ttam-assets/src/svgs/creative/use-account-change-bind-icon.svg';
import { TikTokAccountType } from '../types';
const name = 'ttam-identity-tiktok-account';

export default defineComponent({
  name,
  components: {
    UnbindIcon,
    TTIcon,
  },
  props: {
    data: {
      type: Object as PropType<TikTokAccountType>,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { data } = toRefs(props);
    const isConnected = computed(() => data.value?.id);
    const onLink = () => {
      emit('link');
    };
    const onUnLink = () => {
      emit('unlink');
    };

    return {
      name,
      isConnected,
      onLink,
      onUnLink,
    };
  },
});
